import { MutationTree } from 'vuex'
import { StorageState } from './state'
import { SET_STATE } from './mutation-types'

export default {
  [SET_STATE](state, providedState) {
    state.state = providedState
  }
} as MutationTree<StorageState>
